export default "__VITE_ASSET__CDNcTJuK__"